export default "__VITE_ASSET__Cn1xBh1g__"